import {
  filter
} from 'lodash'

export const checkIfErrorCodePresent = (error, errorCode) => {
  if (error.response && error.response.data && typeof error.response.data.errors === 'object') {
    let errors = error.response.data.errors

    return filter(errors, error => error.code === errorCode).length >= 1
  }

  return false
}

export const gatherErrors = (error, errorCode) => {
  const errorHash = filter(error.response.data.errors, error => error.code === errorCode)[0]
  if (errorHash) {
    return errorHash.meta
  }
  return {}
}
